import {useMutation, useQuery} from 'react-query';

import useFetch from '~api/useFetch';
import {ApiEndpoints} from '~constants/api';
import {
    PlotsReservationsDeleteData,
    PlotsReservationsDeleteResponse,
    PlotsReservationsPostData,
    PlotsReservationsPostResponse,
    PlotsReservationsResponse,
} from '~types/Plots';

export function useFetchPlotsReservations(enabled: boolean) {
    const {apiGet} = useFetch();

    return useQuery<PlotsReservationsResponse>(
        [ApiEndpoints.PlotsReservation],
        () => apiGet(ApiEndpoints.PlotsReservation, {}),
        {enabled},
    );
}

export function usePostPlotsReservations(ids: number[]) {
    const {apiPost} = useFetch();

    return useMutation<PlotsReservationsPostResponse, {}, PlotsReservationsPostData>(
        [ApiEndpoints.PlotsReservation, ids],
        (data) =>
            apiPost(ApiEndpoints.PlotsReservation, {
                withJwtToken: true,
                data,
            }),
    );
}

export function useDeletePlotsReservations(ids: number[]) {
    const {apiDelete} = useFetch();

    return useMutation<
        PlotsReservationsDeleteResponse,
        {},
        PlotsReservationsDeleteData
    >([ApiEndpoints.PlotsReservation, ids], (data) =>
        apiDelete(ApiEndpoints.PlotsReservation, {
            withJwtToken: true,
            data,
        }),
    );
}
